import styled from "styled-components";
import { Button as AntButton } from 'antd';
import { IMG_WALLET_CARD_BG } from '@assets';

export const RootContainer = styled.div`
padding: 24px 16px 16px 16px;
height: calc(100vh - 176px);
overflow-y: auto;
`;

export const Loader = styled.div`
height: calc(100vh - 136px);
display: flex;
align-items: center;
justify-content: center;
`;

export const EmptyBox = styled.div`
height: calc(100vh - 136px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
`;

export const EmptyText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;

export const Item = styled.div`
padding: 30px 13px 13px 13px;
margin-bottom: 30px;
border-radius: 20px;
background: #F8EEFF;
position: relative;

display: flex;
flex-direction: column;
gap: 12px;

.ant-space .ant-space-item {
    flex: 1;
}
`;

export const Divider = styled.div`
width: 100%;
height: 1px;
background: #E5E0F5;
`;

export const DateBox = styled.div`
position: absolute;
top: -16px;
left: 50%;
transform: translate(-50%, 0%);

min-width: 38%;
text-align: center;
padding: 7px;
border-radius: 8px;
background: linear-gradient(180deg, #9027E1 0%, #58297B 104.12%);

font-size: 14px;
font-weight: 400;
color: #fff;
`;

export const Text = styled.div`
font-size: 14px;
font-weight: 400;
color: #000;
`;

export const LightText = styled.div`
font-size: 14px;
font-weight: 400;
color: #49028E;
text-align: right;
`;

export const StatusBox = styled.div`
padding: 5px 10px;
border: 1px solid #9027E1;
border-radius: 5px;
display: inline;

font-size: 12px;
font-weight: 400;
color: #000;
`;

export const Button = styled(AntButton)`
	box-sizing: border-box !important ;
	position: fixed;
	bottom: 12px;
    width: calc(100% - 32px);
    max-width: 448px;
    margin-left: 16px;
	height: 52px !important;
	border-radius: 12px !important;
	background-color: #49028e !important;

	color: #ffffff !important;
	font-size: 16px !important;
	font-style: normal;
	font-weight: 500 !important;
	line-height: 1.5;

	:hover {
		background-color: #49028e !important;
		color: #ffffff !important;
	}
`;

export const TopBox = styled.div`
	padding: 10px 16px;
	margin-bottom: 39px;
	border-radius: 8px;
	background-image: url(${IMG_WALLET_CARD_BG});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;

	font-size: 16px;
	font-weight: 500;
	line-height: 1.5;
	color: #fff;
	text-align: center;
`;